import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Content } from './styles';
import Calendar from '~/assets/calendario_repasse_2025.webp';

export default function Calendary() {
  const property = useSelector(state => state.property.property);

  function handlePrint(elementId, uniqueIframeId) {
    const content = document.getElementById(elementId);
    let pri;
    if (document.getElementById(uniqueIframeId)) {
      pri = document.getElementById(uniqueIframeId).contentWindow;
    } else {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('title', uniqueIframeId);
      iframe.setAttribute('id', uniqueIframeId);
      iframe.setAttribute(
        'style',
        'height: 0px; width: 0px; position: absolute;'
      );
      document.body.appendChild(iframe);
      pri = iframe.contentWindow;
    }
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  return (
    <Container>
      <div className="header">
        <h1>{property.topic}</h1>

        <div>
          <span>Ref.: {property.reference}</span>
          <span>Nº do negócio: {property.businessId}</span>
          <span>{property.address}</span>
        </div>
      </div>
      <Content>
        <div id="img">
          <img src={Calendar} alt="Calendário de repasse 2021" />
        </div>

        <button
          type="button"
          className="button"
          onClick={() => handlePrint('img', 'iframe')}
        >
          IMPRIMIR
        </button>
      </Content>
    </Container>
  );
}
